import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {AboutUsComponent} from './components/about-us/about-us.component';
import {ConditionsComponent} from './components/conditions/conditions.component';
import {PrivacyComponent} from './components/privacy/privacy.component';
import {PersonalDataComponent} from './components/onboarding/personal-data/personal-data.component';
import {ContactDataComponent} from './components/onboarding/contact-data/contact-data.component';
import {PhotosComponent} from './components/onboarding/photos/photos.component';
import {ContractsComponent} from './components/onboarding/contracts/contracts.component';
import {OnboardingComponent} from './components/onboarding/onboarding.component';
import {PageNotFoundComponent} from './components/http-status/page-not-found/page-not-found.component';
import {LoginComponent} from './components/login/login.component';
import {BalanceComponent} from './components/account/balance/balance.component';
import {AccountComponent} from './components/account/account.component';
import {MainComponent} from './components/main/main.component';
import {CancelRequestComponent} from './components/cancel-request/cancel-request.component';
import {AdditionalIdentificationComponent} from './components/onboarding/additional-identification/additional-identification.component';
import {OnlyLoggedInUsersGuard} from './guards/OnlyLoggedInUsers.guard';
import {CancellationComponent} from './components/account/cancellation/cancellation.component';
import {PhoneNumberChangeComponent} from './components/account/phone-number-change/phone-number-change.component';
import {EmailChangeComponent} from './components/account/email-change/email-change.component';
import {FaqComponent} from './components/shared/faq/faq.component';
import {ContactUsComponent} from './components/shared/contact-us/contact-us.component';
import {PasswordChangeComponent} from './components/account/password-change/password-change.component';
import {ContactUsAccountComponent} from './components/account/contact-us-account/contact-us-account.component';
import {TargetAccountComponent} from './components/account/target-account/target-account.component';
import {CreateBarcodeComponent} from './components/account/create-barcode/create-barcode.component';
import {TransfersComponent} from './components/account/transfers/transfers.component';
import {AdditionalQuestionsComponent} from './components/onboarding/additional-questions/additional-questions.component';
import {PasswordRecoveryComponent} from './components/shared/password-recovery/password-recovery.component';
import {AccountStatementComponent} from './components/account/account-statement/account-statement.component';
import {ActivationCardHelpComponent} from './components/account/activation-card-help/activation-card-help.component';
import {EndScreenComponent} from './components/onboarding/end-screen/end-screen.component';
import {UsaIdsScreenComponent} from './components/onboarding/usa-ids-screen/usa-ids-screen.component';
import {PasswordResetComponent} from './components/password-reset/password-reset.component';
import {EmailConfirmationComponent} from './components/email-confirmation/email-confirmation.component';
import {RedirectComponent} from './components/shared/redirect/redirect.component';
import {MyReferralsComponent} from './components/referrals/my-referrals/my-referrals.component';
import {MobileAppComponent} from './components/mobile-app/mobile-app.component';
import {ReferralCodeComponent} from './components/referrals/referral-code/referral-code.component';
import {AddBrokerComponent} from './components/referrals/add-broker/add-broker.component';
import {AddReferrerScreenComponent} from './components/onboarding/add-referrer-screen/add-referrer-screen.component';
import {TransactionHistoryComponent} from './components/account/transaction-history/transaction-history.component';
import {NewCodeComponent} from './components/account/new-code/new-code.component';
import {SelfieComponent} from './components/onboarding/selfie/selfie.component';
import {WebRedirectComponent} from './components/shared/web-redirect/web-redirect.component';
import {StartScreenComponent} from './components/onboarding/start-screen/start-screen.component';
import {ConditionsRemittanceComponent} from './components/remittance/conditions-remittance/conditions-remittance.component';
import {PrivacyRemittanceComponent} from './components/remittance/privacy-remittance/privacy-remittance.component';
import {ContactUsGenericComponent} from './components/shared/contact-us-generic/contact-us-generic.component';
import {UsaComponent} from './components/mobile-app/usa/usa.component';
import {MexComponent} from './components/mobile-app/mex/mex.component';
import { HubappComponent } from './components/mobile-app/hubapp/hubapp.component';
import { RemittanceComponent } from './components/mobile-app/remittance/remittance/remittance.component';
import { MaintenanceGuard } from './guards/maintenance.guard';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';

const routes: Routes = [
  {
    // path: '', component: MainComponent, canActivate: [MaintenanceGuard], children: [
      path: '', component: MainComponent, children: [

      {path: '', component: HomeComponent},
      {path: 'aboutUs', component: AboutUsComponent},
      {path: 'conditions', component: ConditionsComponent},
      {path: 'privacy', component: PrivacyComponent},
      {path: 'login', component: LoginComponent, canActivate: [MaintenanceGuard]},
      {path: 'contactUs', component: ContactUsComponent},
      {path: 'passwordRecovery', component: PasswordRecoveryComponent},
      {path: 'resetPass/:id', component: PasswordResetComponent},
      {path: 'emailConfirmation/:id', component: EmailConfirmationComponent},
      {path: 'mobileApp/:code', component: MobileAppComponent},
      {path: 'mobileApp', component: MobileAppComponent},
      {path: 'usaApp', component: UsaComponent},
      {path: 'mexapp', component: MexComponent},
      {path: 'cancelRequest/:token', component: CancelRequestComponent},
      {path: 'faq', component: FaqComponent},
      {

        path: 'onboarding', component: OnboardingComponent, canActivate: [MaintenanceGuard], children: [
          {path: '', redirectTo: 'start', pathMatch: 'full'},
          {path: 'start', component: StartScreenComponent},
          {path: 'addReferrer', component: AddReferrerScreenComponent},
          {path: 'contactData', component: ContactDataComponent},
          {path: 'usaIds', component: UsaIdsScreenComponent},
          {path: 'photos', component: PhotosComponent},
          {path: 'personalData', component: PersonalDataComponent},
          {path: 'contracts', component: ContractsComponent},
          {path: 'additionalIdentification', component: AdditionalIdentificationComponent},
          {path: 'end', component: EndScreenComponent},
          {path: 'recovery/:token', component: StartScreenComponent},
          {path: 'additionalQuestions', component: AdditionalQuestionsComponent},
          {path: 'selfie', component: SelfieComponent}
        ]
      },
    ]
  },
  {
    path: 'account', component: AccountComponent, canActivate: [OnlyLoggedInUsersGuard], children: [
      {path: 'balance', component: BalanceComponent},
      {path: 'transactionHistory', component: TransactionHistoryComponent},
      {path: 'cancellation', component: CancellationComponent},
      {path: 'phoneNumberChange', component: PhoneNumberChangeComponent},
      {path: 'emailChange', component: EmailChangeComponent},
      {path: 'faq', component: FaqComponent},
      {path: 'contactUsAccount', component: ContactUsAccountComponent},
      {path: 'passwordChange', component: PasswordChangeComponent},
      {path: 'myReferrals', component: MyReferralsComponent},
      {path: 'referralCode', component: ReferralCodeComponent},
      {path: 'addReferral', component: AddBrokerComponent},
      {path: 'targetAccount/:mode', component: TargetAccountComponent},
      {path: 'transfers', component: TransfersComponent},
      {path: 'newCode', component: NewCodeComponent},
      {path: 'createBarcode', component: CreateBarcodeComponent},
      {path: 'accountStatement', component: AccountStatementComponent},
      {path: 'activationCardHelp', component: ActivationCardHelpComponent}
    ]
  },
  {path: 'web/:code', component: WebRedirectComponent},
  {path: 'redirect/:data/:section/:type', component: RedirectComponent},
  {path: 'redirect/:data/:section', component: RedirectComponent},
  {path: 'redirect/:data', component: RedirectComponent},
  {path: 'redirect', component: RedirectComponent},
  {path: 'addReferrer', component: RedirectComponent},
  {path: 'remittanceConditions', component: ConditionsRemittanceComponent},//UNICA CARD CONFIG
  {path: 'remittancePrivacy', component: PrivacyRemittanceComponent}, //UNICA CARD CONFIG
  {path: 'contact', component: ContactUsGenericComponent},

  {path: 'hubapp', component: HubappComponent},
  {path: 'remittance', component: RemittanceComponent},
  {path: 'maintenance', component: MaintenanceComponent},

  {path: '**', component: PageNotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
